import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "../css/AllVideos.css";
import { REACT_APP_API_URL } from "../env";

const AllVideos = () => {
  const [videos, setVideos] = useState([]);
  const [popupVideo, setPopupVideo] = useState(null);
  const popupVideoRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${REACT_APP_API_URL}/api/dashboard/admin/list-all-videos?mode=gallery`)
      .then((res) => {
        // console.log("API RESPONSE:", res.data);
        const list = res.data.data || [];

        const filtered = list
          .filter((v) => v.bitStatus == 0)
          .map((v) => ({
            id: v.intVideoID,
            title: v.vchLabel,
            url:
              v.vchVideo1Mode === "file"
                ? `${REACT_APP_API_URL}${v.vchVideo1DesktopPath}`
                : v.vchVideo1DesktopLink,
          }));

        setVideos(filtered);
      })
      .catch((err) => console.log("API Error:", err));
  }, []);

  const handlePopupClose = () => {
    setPopupVideo(null);
  };
  useEffect(() => {
    if (popupVideo && popupVideoRef.current) {
      popupVideoRef.current.play().catch(() => { });
    }
  }, [popupVideo]);

  return (
    <div className="all-videos-page">
      <div className="video-banner-container">
        <img
          src="/images/unsplash4.jpg"
          alt="Video Banner"
          className="video-banner-image"
        />
        <h2 className="video-banner-text">VIDEO VAULT</h2>
      </div>
      <div className="all-videos-grid">
        {videos.map((v) => (
          <div
            key={v.id}
            className="video-card pdf-style"
            onClick={() => setPopupVideo(v)}
          >
            <div className="video-frame">
              <video
                src={v.url}
                muted
                className="video-thumb"
                playsInline
                onMouseOver={(e) => {
                  const vid = e.target;
                  vid.currentTime = 0;
                  vid.play().catch(() => { });
                }}
                onMouseOut={(e) => {
                  const vid = e.target;
                  vid.pause();
                }}
              />
            </div>
            <h3 className="pdf-title">{v.title}</h3>
          </div>
        ))}
      </div>
      {popupVideo && (
        <div className="popup-overlay" onClick={handlePopupClose}>
          <div
            className="popup-video"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              className="popup-video-player"
              src={popupVideo.url}
              controls
              autoPlay
              ref={popupVideoRef}
              playsInline
            />
            <button className="close-popup" onClick={handlePopupClose}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllVideos;
